import React, { useEffect } from 'react';
import { Button, ButtonVariant } from '@patternfly/react-core';
import { ExclamationTriangleIcon } from '@patternfly/react-icons';
import { NEW_DOMAIN } from '@app/config';

const isConfigured = (value?: string): boolean => !!value && value !== 'undefined';

export const isLegacyDomain = (): boolean =>
  isConfigured(NEW_DOMAIN) && window.location.hostname !== NEW_DOMAIN;

const CONFLUENCE_URL = 'https://teladochealth.atlassian.net/wiki/x/CYMsVQ';

const getNewDomainUrl = () =>
  `https://${NEW_DOMAIN}${window.location.pathname}${window.location.search}`;

export const LegacyDomainAlert: React.FunctionComponent = () => {
  useEffect(() => {
    const dark = localStorage.getItem('devex-dark-theme') === 'true';
    document.documentElement.classList.toggle('light-theme', !dark);
    document.body.classList.toggle('light-theme', !dark);
  }, []);

  return (
    <div className="dx-bullseye" style={{ height: '100vh', background: 'var(--bg-primary)' }}>
      <div className="dx-card" style={{ maxWidth: '30rem' }}>
        <div className="dx-empty-state" style={{ padding: '2.5rem 1.5rem', gap: '0.75rem' }}>
          <ExclamationTriangleIcon
            className="dx-empty-state__icon"
            style={{ color: 'var(--status-warning-text)', marginBottom: 0 }}
          />
          <h1 className="dx-empty-state__title">The DevEx portal has moved to a new domain</h1>
          <p className="dx-empty-state__body" style={{ fontSize: '16px', marginBottom: '0.5rem' }}>
            It has moved to <strong>https://{NEW_DOMAIN}</strong>. This domain (
            {window.location.hostname}) will be disabled soon. Please update your bookmarks and
            any saved links.{' '}
            <a href={CONFLUENCE_URL} target="_blank" rel="noopener noreferrer">
              Read more about this change
            </a>
            .
          </p>
          <div className="dx-empty-state__footer" style={{ marginTop: '0.75rem' }}>
            <Button component="a" href={getNewDomainUrl()} variant={ButtonVariant.primary}>
              Continue to https://{NEW_DOMAIN}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
